module.exports = __webpack_public_path__ + "static/media/Margarita V.a7ba58e7.png";